module.exports = __webpack_public_path__ + "img/menu.3cf0ae23.svg";